import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';
import { Env } from '@/config/env';
import { userInfoStore } from '@/models';
import { IApiModel } from '@/types/communal.types';
import qs from 'qs';

export const api: AxiosInstance = axios.create({
  baseURL: Env.apiUrl,
  timeout: 500000,
});

/* 请求拦截器 */
api.interceptors.request.use(
  (config) => {
    if (userInfoStore.token) {
      (config.headers as AxiosRequestHeaders).Authorization = userInfoStore.token;
    }
    // 处理list的问题
    if (config.method === 'get') {
      config.paramsSerializer = params => {
        return qs.stringify(params, { indices: false });
      };
    }
    return config;
  },
  (error) => {
    console.error('请求api出现错误', error);
    return Promise.reject(error);
  },
);
/* 响应拦截器 */
api.interceptors.response.use(
  (response) => {
    if (
      response.headers['content-type'] === 'application/octet-stream' ||
            response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return response;
    }

    if (response.data.Code && response.data.Code !== 200) {
      return Promise.reject(new Error(response.data.Msg));
    }
    return response.data.Data ? response.data : {
      Data: response.data.Data,
      Msg: response.data.Msg,
      Code: response.data.Code,
    };
  },
  (error) => {
    console.error('访问api报错啦!!', error.message);
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;
        case 401: {
          error.message = '未授权，请登录';
          const resultError: IApiModel<string | undefined> = {
            Data: undefined,
            Msg: error.message,
            Code: 401,
          };
          userInfoStore.setToken('');
          return resultError;
        }
        case 403:
          error.message = '拒绝访问';
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = '请求超时';
          break;
        case 500:
          error.message = '服务器内部错误';
          break;
        case 501:
          error.message = '服务未实现';
          break;
        case 502:
          error.message = '网关错误';
          break;
        case 503:
          error.message = '服务不可用';
          break;
        case 504:
          error.message = '网关超时';
          break;
        case 505:
          error.message = 'HTTP版本不受支持';
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  },
);
